// extracted by mini-css-extract-plugin
module.exports = {"ConfirmDialog":"ConfirmDialog_ConfirmDialog__1mzSt","backdrop":"ConfirmDialog_backdrop__kcx8o","dialog":"ConfirmDialog_dialog__1bgS5","controls":"ConfirmDialog_controls__3UPEv"};